import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M8 7.673 5.285 10.39a.48.48 0 0 1-.349.141.47.47 0 0 1-.354-.141.48.48 0 0 1-.145-.351q0-.207.145-.352L7.578 6.69A.55.55 0 0 1 8 6.52q.12 0 .224.038.104.039.198.132l2.996 2.996q.139.139.142.348a.47.47 0 0 1-.142.355.48.48 0 0 1-.351.145.48.48 0 0 1-.352-.145z" }, null, -1)
  ])))
}
export default { render: render }